let map;
let daumMap;
let geocoder;
let markerImage;

export default {
  inserted(el, binding, vnode) {
    if (!window.daum) {
      return new Error('daum map is not loaded');
    }

    const { isMapShow } = binding.value;

    daumMap = window.daum.maps;

    if (isMapShow) {
      let container = el;
      let centerPoint = new daumMap.LatLng(37.5076883, 127.0577353);
      let options = {
        center: centerPoint,
        level: 2
      };

      map = new daumMap.Map(container, options); //지도 생성 및 객체 리턴
      let imageSrc = '//cdn.fiflbox.com/admin/fifl_marker.png', // 마커이미지의 주소입니다
        imageSize = new daum.maps.Size(23, 32), // 마커이미지의 크기입니다
        imageOption = { offset: new daum.maps.Point(12, 32) }; // 마커이미지의 옵션입니다. 마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다.

      markerImage = new daum.maps.MarkerImage(imageSrc, imageSize, imageOption);
      // 마커를 생성합니다
      let marker = new daum.maps.Marker({
        position: centerPoint,
        image: markerImage // 마커이미지 설정
      });
      marker.setMap(map);
    }
    geocoder = new daumMap.services.Geocoder();
  },
  update(el, binding, vnode) {
    if (binding.value.address === binding.oldValue.address) {
      return;
    }
    let { address, isMapShow } = binding.value;
    geocoder.addressSearch(address, (results, status) => {
      if (status === daumMap.services.Status.OK) {
        let coords = results[0];
        if (isMapShow) {
          let mapCenter = new daumMap.LatLng(coords.y, coords.x);
          map.setCenter(mapCenter);

          // 마커를 생성합니다
          let marker = new daum.maps.Marker({
            position: mapCenter,
            image: markerImage // 마커이미지 설정
          });

          marker.setMap(map);
        }

        vnode.context.$emit('centerChange', {
          latitude: coords.y,
          longitude: coords.x
        });
      }
    });
  }
};
